import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

import {selectUser, useAppSelector} from "~/modules/redux";
import {TERMS_TO_UPDATE_PATH} from "~/modules/routing";

export const useUpdatedTerms = () => {
  const navigate = useNavigate();
  const {maker, impersonation} = useAppSelector(selectUser);

  useEffect(() => {
    if (impersonation) return;
    if (!maker?.onboarding?.termsToUpdate.length) return;
    navigate(TERMS_TO_UPDATE_PATH);
  }, [navigate, impersonation, maker]);
};
